/**
 * Cart upsell recommendations.
 * Extracted from sections/product-upsell.liquid.
 *
 * All configuration is read from data-* attributes on the section root
 * (data-section-url, data-source-ids, data-cart-handles, data-total-limit,
 * data-exclude-in-cart), so this file contains no Liquid.
 */
window.recommendationsComponent = function recommendationsComponent() {
  return {
    loading: true,
    hasContent: false,
    _didRun: false,

    async init() {
      if (this._didRun) return;
      this._didRun = true;

      const root = this.$el;
      const baseUrl = root.getAttribute('data-section-url') || '';
      const totalLimit = parseInt(root.getAttribute('data-total-limit') || '4', 10);
      const excludeInCart = root.getAttribute('data-exclude-in-cart') === 'true';

      let sources = (root.getAttribute('data-source-ids') || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      sources = Array.from(new Set(sources));

      const cartHandles = (root.getAttribute('data-cart-handles') || '').split(',').filter(Boolean);
      const inCart = new Set(cartHandles);

      if (!baseUrl || sources.length === 0) {
        this.loading = false;
        this.hasContent = false;
        return;
      }

      const mount = this.$refs.mount;
      const collected = [];
      const seenHref = new Set();

      const fetchFor = async (productId) => {
        const url = baseUrl + '&product_id=' + encodeURIComponent(productId);
        const html = await fetch(url, { credentials: 'same-origin' }).then((r) => r.text());
        const wrap = document.createElement('div');
        wrap.innerHTML = html;

        // Prefer exact section id; fall back to common classes
        let scope =
          wrap.querySelector('#' + CSS.escape(root.id)) ||
          wrap.querySelector('.section-cart-upsell, .cart-upsell') ||
          wrap;

        // Pull the server-rendered li items
        let items = Array.from(scope.querySelectorAll('li.cart-upsell__item'));

        // Optional client-side exclusion (in case server didn't)
        if (excludeInCart) {
          items = items.filter((li) => {
            const a = li.querySelector('a[href*="/products/"]');
            const handle = a?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
            return !(handle && inCart.has(handle));
          });
        }

        // Ensure width classes are present even if snippet changes later
        items.forEach((li) => {
          li.classList.add('w-[calc(50%-20px)]', 'lg:w-[284px]');
        });

        return items;
      };

      try {
        for (const pid of sources) {
          if (collected.length >= totalLimit) break;
          const lis = await fetchFor(pid).catch(() => []);
          for (const li of lis) {
            if (collected.length >= totalLimit) break;
            const href = li.querySelector('a')?.getAttribute('href') || '';
            if (href && seenHref.has(href)) continue;
            seenHref.add(href);
            collected.push(li);
          }
        }
      } finally {
        if (mount && collected.length) {
          collected.slice(0, totalLimit).forEach((li) => mount.appendChild(li));
          this.hasContent = true;
        } else {
          this.hasContent = false;
        }
        this.loading = false;
      }
    },
  };
};
